module.exports = __webpack_public_path__ + "static/media/close-icon.cd9b3b7c.svg";